import { render, staticRenderFns } from "./SampleOrderFixApply.vue?vue&type=template&id=524d5e4b&scoped=true"
import script from "./SampleOrderFixApply.vue?vue&type=script&lang=js"
export * from "./SampleOrderFixApply.vue?vue&type=script&lang=js"
import style0 from "./SampleOrderFixApply.vue?vue&type=style&index=0&id=524d5e4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d5e4b",
  null
  
)

export default component.exports